import { SecuritiesOptions } from "../../types";

export const employmentStatus: Record<
  string,
  { value: SecuritiesOptions["employmentStatus"]; label: string }[]
> = {
  es: [
    { value: "EMPLOYEE", label: "Empleado" },
    { value: "INDEPENDENT", label: "Autónomo" },
    { value: "UNEMPLOYED", label: "Desempleado" },
    { value: "RETIRED", label: "Jubilado" },
    { value: "STUDENT", label: "Estudiante" },
  ],
  en: [
    { value: "EMPLOYEE", label: "Employed" },
    { value: "INDEPENDENT", label: "Self employed" },
    { value: "UNEMPLOYED", label: "Unemployed" },
    { value: "RETIRED", label: "Retired" },
    { value: "STUDENT", label: "Student" },
  ],
};

export const genderOptions: Record<
  string,
  { value: SecuritiesOptions["gender"]; label: string }[]
> = {
  es: [
    { value: "MALE", label: "Masculino" },
    { value: "FEMALE", label: "Femenino" },
    { value: "OTHER", label: "Otro" },
  ],
  en: [
    { value: "MALE", label: "Male" },
    { value: "FEMALE", label: "Female" },
    { value: "OTHER", label: "Other" },
  ],
};

export const civilStatusOptions: Record<
  string,
  { value: SecuritiesOptions["civilStatus"]; label: string }[]
> = {
  es: [
    { value: "SINGLE", label: "Soltero/a" },
    { value: "MARRIED", label: "Casado/a" },
    { value: "WIDOWED", label: "Viudo/a" },
    { value: "DIVORCED", label: "Divorciado/a" },
    { value: "CONCUBINAGE", label: "Concubinato" },
  ],
  en: [
    { value: "SINGLE", label: "Single" },
    { value: "MARRIED", label: "Married" },
    { value: "WIDOWED", label: "Widowed" },
    { value: "DIVORCED", label: "Divorced" },
    { value: "CONCUBINAGE", label: "Concubinage" },
  ],
};

// Rami: These translations might be too literal, but it's hard to avoid, as
// every country has its own nomenclature. We could either target one in
// particular (e.g. US) to improve the translation quality or keep it as is.
export const educationLevelOptions: Record<
  string,
  { value: SecuritiesOptions["educationLevel"]; label: string }[]
> = {
  es: [
    { value: "NONE", label: "Sin estudios" },
    { value: "PRIMARY", label: "Primario" },
    { value: "SECONDARY", label: "Secundario" },
    { value: "TERTIARY", label: "Terciario" },
    { value: "UNIVERSITY", label: "Universitario" },
    { value: "POSTGRADUATE", label: "Postgrado" },
    { value: "MASTER", label: "Maestría" },
    { value: "DOCTORATE", label: "Doctorado" },
  ],
  en: [
    { value: "NONE", label: "No education" },
    { value: "PRIMARY", label: "Primary" },
    { value: "SECONDARY", label: "Secondary" },
    { value: "TERTIARY", label: "Tertiary" },
    { value: "UNIVERSITY", label: "University" },
    { value: "POSTGRADUATE", label: "Postgraduate" },
    { value: "MASTER", label: "Master" },
    { value: "DOCTORATE", label: "Doctorate" },
  ],
};

export const documentTypesOptions: Record<
  string,
  { value: SecuritiesOptions["documentType"]; label: string }[]
> = {
  es: [
    { value: "DNI", label: "Documento Nacional de Identidad" },
    { value: "PASSPORT", label: "Pasaporte" },
  ],
  en: [
    { value: "DNI", label: "Argentine Identity Document (DNI)" },
    { value: "PASSPORT", label: "Passport" },
  ],
};

export const taxIdTypesOptions: Record<
  string,
  { value: SecuritiesOptions["taxIdType"]; label: string }[]
> = {
  es: [
    { value: "CUIT", label: "CUIT" },
    { value: "CUIL", label: "CUIL" },
    { value: "TAX_ID", label: "Tax ID" },
  ],
  en: [
    { value: "CUIT", label: "CUIT" },
    { value: "CUIL", label: "CUIL" },
    { value: "TAX_ID", label: "Tax ID" },
  ],
};

export const yesOrNoBoolOptions = {
  es: [
    { value: "SI", label: "Sí" },
    { value: "NO", label: "No" },
  ],
  en: [
    { value: "SI", label: "Yes" },
    { value: "NO", label: "No" },
  ],
};

export const invesmentsKnowlageOptions: Record<
  string,
  { value: SecuritiesOptions["investmentKnowlageLevel"]; label: string }[]
> = {
  es: [
    { value: "LIMITED", label: "Limitado" },
    { value: "MODERATED", label: "Moderado" },
    { value: "EXTENSIVE", label: "Extensivo" },
    { value: "NONE", label: "Ninguno" },
  ],
  en: [
    { value: "LIMITED", label: "Limited" },
    { value: "MODERATED", label: "Moderated" },
    { value: "EXTENSIVE", label: "Extensive" },
    { value: "NONE", label: "None" },
  ],
};

export const investmentTools: Record<
  string,
  {
    value: SecuritiesOptions["investmentTool"];
    name: SecuritiesOptions["investmentToolsKeys"];
    label: string;
  }[]
> = {
  es: [
    {
      value: "ANNUITIES_FIXED",
      name: "annuitiesFixed",
      label: "Annuities Fixed",
    },
    {
      value: "ANNUITIES_VARIABLE",
      name: "annuitiesVariable",
      label: "Annuities variable",
    },
    {
      value: "ETF",
      name: "etfs",
      label: "ETF",
    },
    {
      value: "UNITARY_INVESTMENT_TRUSTS",
      name: "uits",
      label: "Fondos comunes de inversión",
    },
    {
      value: "FIXED_INCOME",
      name: "fixedIncome",
      label: "Renta fija",
    },
    {
      value: "INSURANCE",
      name: "insurance",
      label: "Seguros",
    },
    {
      value: "MUTUAL_FUNDS",
      name: "mutualFunds",
      label: "Fondos mutuos",
    },
    {
      value: "COMMODITIES_FUTURES",
      name: "commoditiesAndFutures",
      label: "Commodities y futuros",
    },
    {
      value: "EQUITIES",
      name: "equities",
      label: "Acciones",
    },
    {
      value: "OPTIONS",
      name: "options",
      label: "Opciones",
    },
    {
      value: "PRECIOUS_METALS",
      name: "preciousMetals",
      label: "Metales preciosos",
    },
    {
      value: "REAL_ESTATE",
      name: "realEstate",
      label: "Real estate",
    },
    {
      value: "OTHERS",
      name: "others",
      label: "Otros",
    },
  ],
  en: [
    {
      value: "ANNUITIES_FIXED",
      name: "annuitiesFixed",
      label: "Fixed Annuities",
    },
    {
      value: "ANNUITIES_VARIABLE",
      name: "annuitiesVariable",
      label: "Variable Annuities",
    },
    {
      value: "ETF",
      name: "etfs",
      label: "Exchange Traded Funds",
    },
    {
      value: "UNITARY_INVESTMENT_TRUSTS",
      name: "uits",
      label: "Unit Investment Trust",
    },
    {
      value: "FIXED_INCOME",
      name: "fixedIncome",
      label: "Fixed Income",
    },
    {
      value: "INSURANCE",
      name: "insurance",
      label: "Insurance",
    },
    {
      value: "MUTUAL_FUNDS",
      name: "mutualFunds",
      label: "Mutual Funds",
    },
    {
      value: "COMMODITIES_FUTURES",
      name: "commoditiesAndFutures",
      label: "Commodities and Futures",
    },
    {
      value: "EQUITIES",
      name: "equities",
      label: "Equities",
    },
    {
      value: "OPTIONS",
      name: "options",
      label: "Options",
    },
    {
      value: "PRECIOUS_METALS",
      name: "preciousMetals",
      label: "Precious Metals",
    },
    {
      value: "REAL_ESTATE",
      name: "realEstate",
      label: "Real Estate",
    },
    {
      value: "OTHERS",
      name: "others",
      label: "Others",
    },
  ],
};

export const accountObjectiveOptions: Record<
  string,
  { value: SecuritiesOptions["accountObjective"]; label: string }[]
> = {
  es: [
    { value: "INCOME", label: "Ingresos" },
    { value: "LONG_TERM_GROWTH", label: "Crecimiento a largo plazo" },
    { value: "SHORT_TERM_GROWTH", label: "Crecimiento a corto plazo" },
  ],
  en: [
    { value: "INCOME", label: "Income" },
    { value: "LONG_TERM_GROWTH", label: "Long-term growth" },
    { value: "SHORT_TERM_GROWTH", label: "Short-term growth" },
  ],
};

export const originOfFundsOptions: Record<
  string,
  { value: SecuritiesOptions["fundOrigin"]; label: string }[]
> = {
  es: [
    { value: "ACCOUNTS_RECEIVABLE", label: "Cuentas por cobrar" },
    { value: "RENTAL_INCOME", label: "Ingresos por alquiler" },
    { value: "INCOME_FROM_PROFITS", label: "Ingresos por ganancias" },
    { value: "MAINTENANCE", label: "Manutención" },
    { value: "LEGAL_AGREEMENT", label: "Acuerdo legal" },
    { value: "INSURANCE_INCOME", label: "Ingresos del seguro" },
    { value: "FAMILY", label: "Familia" },
    { value: "RETIREMENTS_SAVINGS", label: "Ahorros de jubilación" },
    { value: "ROLL_OVER", label: "Rollover" },
    { value: "BUSINESS_SALE", label: "Venta de negocio" },
    { value: "ACCUMULATED_SAVINGS", label: "Ahorro acumulado" },
    { value: "INVESTMENT_INCOME", label: "Ingresos de inversión" },
    { value: "GIFT", label: "Regalo" },
    { value: "SALE_OF_REAL_ESTATE", label: "Ventas de bienes raíces" },
    { value: "LOTTERY_GAMES", label: "Lotería / Juegos" },
    { value: "OTHERS", label: "Otros" },
  ],
  en: [
    { value: "ACCOUNTS_RECEIVABLE", label: "Accounts receivable" },
    { value: "RENTAL_INCOME", label: "Rental income" },
    { value: "INCOME_FROM_PROFITS", label: "Income from profits" },
    { value: "MAINTENANCE", label: "Maintenance" },
    { value: "LEGAL_AGREEMENT", label: "Legal agreement" },
    { value: "INSURANCE_INCOME", label: "Insurance income" },
    { value: "FAMILY", label: "Family" },
    { value: "RETIREMENTS_SAVINGS", label: "Retirement savings" },
    { value: "ROLL_OVER", label: "Rollover" },
    { value: "BUSINESS_SALE", label: "Business sale" },
    { value: "ACCUMULATED_SAVINGS", label: "Accumulated savings" },
    { value: "INVESTMENT_INCOME", label: "Investment income" },
    { value: "GIFT", label: "Gift" },
    { value: "SALE_OF_REAL_ESTATE", label: "Real estate sales" },
    { value: "LOTTERY_GAMES", label: "Lottery / Gambling" },
    { value: "OTHERS", label: "Other" },
  ],
};

export const timeHorizonOptions: Record<
  string,
  { value: SecuritiesOptions["timeHorizon"]; label: string }[]
> = {
  es: [
    { value: "ONE_OR_TWO_YEARS", label: "1 o 2 años" },
    { value: "TWO_TO_FIVE_YEARS", label: "2 a 5 años" },
    { value: "ABOVE_FIVE_YEARS", label: "Más de 5 años" },
  ],
  en: [
    { value: "ONE_OR_TWO_YEARS", label: "1 or 2 years" },
    { value: "TWO_TO_FIVE_YEARS", label: "2 to 5 years" },
    { value: "ABOVE_FIVE_YEARS", label: "More than 5 years" },
  ],
};

export const riskProfileOptions: Record<
  string,
  { value: SecuritiesOptions["accountRiskProfile"]; label: string }[]
> = {
  es: [
    { value: "CONSERVATIVE", label: "Conservador" },
    { value: "MODERATE", label: "Moderado" },
    { value: "AGGRESSIVE", label: "Agresivo" },
    { value: "SPECULATIVE", label: "Especulativo" },
  ],
  en: [
    { value: "CONSERVATIVE", label: "Conservative" },
    { value: "MODERATE", label: "Moderate" },
    { value: "AGGRESSIVE", label: "Aggressive" },
    { value: "SPECULATIVE", label: "Speculative" },
  ],
};

export const regularWithdrawalsReasonOptions: Record<
  string,
  { value: SecuritiesOptions["withdrawalReason"]; label: string }[]
> = {
  es: [
    { value: "PERSONAL_EXPENSES", label: "Gastos personales" },
    { value: "INVESTMENTS", label: "Inversiones" },
    { value: "SCHOOL_TUITION", label: "Matrícula escolar" },
    { value: "OTHERS", label: "Otros" },
  ],
  en: [
    { value: "PERSONAL_EXPENSES", label: "Personal Expenses" },
    { value: "INVESTMENTS", label: "Investments" },
    { value: "SCHOOL_TUITION", label: "School Tuition" },
    { value: "OTHERS", label: "Other" },
  ],
};

export const regularWithdrawalsFrequencyOptions: Record<
  string,
  { value: SecuritiesOptions["withdrawalFrequency"]; label: string }[]
> = {
  es: [
    { value: "MONTHLY", label: "Mensual" },
    { value: "QUARTERLY", label: "Trimestral" },
    { value: "SEMI_ANNUAL", label: "Semi-anual" },
    { value: "ANNUAL", label: "Anual" },
    { value: "OTHER", label: "Otro" },
  ],
  en: [
    { value: "MONTHLY", label: "Monthly" },
    { value: "QUARTERLY", label: "Quarterly" },
    { value: "SEMI_ANNUAL", label: "Semi-annual" },
    { value: "ANNUAL", label: "Annual" },
    { value: "OTHER", label: "Other" },
  ],
};

export const thirdPartyTransfersReasonOptions: Record<
  string,
  { value: SecuritiesOptions["transferReason"]; label: string }[]
> = {
  es: [
    { value: "PERSONAL_EXPENSES", label: "Gastos personales" },
    { value: "INVESTMENTS", label: "Inversiones" },
    { value: "SCHOOL_TUITION", label: "Matrícula escolar" },
    { value: "OTHERS", label: "Otros" },
  ],
  en: [
    { value: "PERSONAL_EXPENSES", label: "Personal Expenses" },
    { value: "INVESTMENTS", label: "Investments" },
    { value: "SCHOOL_TUITION", label: "School Tuition" },
    { value: "OTHERS", label: "Other" },
  ],
};

export const thirdPartyTransfersFrequencyOptions: Record<
  string,
  { value: SecuritiesOptions["transferFrequency"]; label: string }[]
> = {
  es: [
    { value: "MONTHLY", label: "Mensual" },
    { value: "QUARTERLY", label: "Trimestral" },
    { value: "SEMI_ANNUAL", label: "Semi-anual" },
    { value: "ANNUAL", label: "Anual" },
    { value: "OTHER", label: "Otro" },
  ],
  en: [
    { value: "MONTHLY", label: "Monthly" },
    { value: "QUARTERLY", label: "Quarterly" },
    { value: "SEMI_ANNUAL", label: "Semi-annual" },
    { value: "ANNUAL", label: "Annual" },
    { value: "OTHER", label: "Other" },
  ],
};

export const tradeOptionsObjectiveOptions: Record<
  string,
  { value: SecuritiesOptions["investmentObjective"]; label: string }[]
> = {
  es: [
    { value: "INCOME", label: "Ingresos" },
    { value: "LONG_TERM_GROWTH", label: "Crecimiento a largo plazo" },
    { value: "SHORT_TERM_GROWTH", label: "Crecimiento a corto plazo" },
    { value: "INCOME_AND_APPRECIATION", label: "Ingresos y apreciación" },
    { value: "SPECULATION", label: "Especulación" },
    { value: "CAPITAL_PRESERVATION", label: "Preservación de capital" },
    { value: "HEDGE", label: "Cobertura" },
    { value: "OTHER", label: "Otros" },
  ],
  en: [
    { value: "INCOME", label: "Income" },
    { value: "LONG_TERM_GROWTH", label: "Long-term growth" },
    { value: "SHORT_TERM_GROWTH", label: "Short-term growth" },
    { value: "INCOME_AND_APPRECIATION", label: "Income and appreciation" },
    { value: "SPECULATION", label: "Speculation" },
    { value: "CAPITAL_PRESERVATION", label: "Capital preservation" },
    { value: "HEDGE", label: "Hedging" },
    { value: "OTHER", label: "Other" },
  ],
};

export const languageItems = {
  es: [
    { label: "Español", value: "es" },
    { label: "English", value: "en" },
  ],
  en: [
    { label: "Español", value: "es" },
    { label: "English", value: "en" },
  ],
};

export const accountHoldersItems = {
  es: [
    { label: "Solo yo (1 titular)", value: "1" },
    { label: "Dos titulares (2 titulares)", value: "2" },
    { label: "Tres titulares (3 titulares)", value: "3" },
    { label: "Cuatro titulares (4 titulares)", value: "4" },
    { label: "Cinco titulares (5 titulares)", value: "5" },
  ],
  en: [
    { label: "Just me (1 account holder)", value: "1" },
    { label: "Two account holders (2 account holders)", value: "2" },
    { label: "Three accounts holder (3 account holders)", value: "3" },
    { label: "Four account holders (4 account holders)", value: "4" },
    { label: "Five account holders (5 account holders)", value: "5" },
  ],
};

export const dependantsOptions = {
  es: [
    ...[...Array(11).keys()].map((i) => ({
      label: i === 0 ? "Ninguna" : `${i} persona${i == 1 ? "" : "s"}`,
      value: i.toString(),
    })),
    {
      label: "Más de 10 personas",
      value: "11", // Backend expects an integer
    },
  ],

  en: [
    ...[...Array(11).keys()].map((i) => ({
      label: i === 0 ? "None" : `${i} dependant${i == 1 ? "" : "s"}`,
      value: i.toString(),
    })),
    {
      label: "More than 10 dependants",
      value: "11", // Backend expects an integer
    },
  ],
};
